import { render, staticRenderFns } from "./SalesTaxMenu.vue?vue&type=template&id=626a7bc0&scoped=true&"
import script from "./SalesTaxMenu.vue?vue&type=script&lang=js&"
export * from "./SalesTaxMenu.vue?vue&type=script&lang=js&"
import style0 from "./SalesTaxMenu.vue?vue&type=style&index=0&id=626a7bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a7bc0",
  null
  
)

export default component.exports